import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display:flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  .hidden {
    visibility: hidden;
  }
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  > div {
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 1rem;
    gap: 1.5rem;
    border-radius: 6px;
    background-color: #ffffff;
    > .error{
      color: rgb(251, 75, 75);
      > input {
        border-color: rgb(251, 75, 75);
      }
      > input::placeholder{
        color:red;
      }
    }
    > div {
      position: relative;
      display: flex;
      width: 100%;
      flex-direction: column;
      gap: .5rem;
      > input {
        outline: none;
        border: none;
        width: 100%;
        height: 2.5rem;
        border-radius: 4px;
        border: solid 1px #dfe0e1;
        padding: 0px 2.75rem 0px 1rem;
        transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
        &:hover{
          border-color: #3788d8;
        }
        &:active, &:focus {
          border-width: 2px;
          border-color: #3788d8;
        }
      }
      > span {
        position: absolute;
        bottom: 7px;
        right: 10px;
        display: flex;
        font-size: 1.5rem;
        cursor: pointer;
        color: #bfc2c4;
      }
    }
  }
  > div:nth-child(2) {
    gap: .4rem;
    > .has {
      color:#007d00;
    }
    > span {
      color: #a6a6a6;
      margin-bottom: 5px;
    }
    > div {
      flex-direction: row;
      color: rgb(251, 75, 75);
    }
  }
  > div:nth-child(3){
    flex-direction: row;
    justify-content: space-between;
    > button {
      outline: none;
      border: none;
      border-radius: 4px;
      padding: .75rem 1.75rem .75rem 1.75rem;
      cursor: pointer;
      color: #ffffff;
      font-weight: bolder;
      background: transparent;
      cursor: pointer;
      &:not(:disabled) {
        &:hover {
          opacity: 0.8;
        }
      }
      &:disabled {
        opacity: .3;
        cursor: default;
      }
    }
    > .clear {
      background-color:#fbc02d;
    }
    > .cancel {
      background-color: rgb(251, 75, 75);
    }
    > .save {
      background-color: rgb(11, 170, 150);
    }
  }
`;
export const InProgress = styled.div`   
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 6px;
  > div {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .trwDs {
      max-height: 200px;
      margin-bottom: 2rem;
    }
    .loader {
      width: 50px;
      aspect-ratio: 1;
      display: grid;
      border: 4px solid #0000;
      border-radius: 50%;
      border-right-color: #25b09b;
      animation: l15 1s infinite linear;
    }
    .loader::before,
    .loader::after {
      content: "";
      grid-area: 1/1;
      margin: 2px;
      border: inherit;
      border-radius: 50%;
      animation: l15 2s infinite;
    }
    .loader::after {
      margin: 8px;
      animation-duration: 3s;
    }
    @keyframes l15{ 
      100% {transform: rotate(1turn)}
    }
    .m-b {
      margin-bottom: .5rem;
    };
    span {
      margin-top: .5rem;
      font-size: 1.3rem;
      font-weight: 500;
      color: #94989c;
    };
  };
`;